// context/DebugContext.tsx
"use client";

import { createContext, useContext } from "react";

type DebugContextType = {
  debug: boolean;
};

export const DebugContext = createContext<DebugContextType>({
  debug: false,
});

export function DebugProvider({
  debug,
  children,
}: {
  debug: boolean;
  children: React.ReactNode;
}) {
  return (
    <DebugContext.Provider value={{ debug }}>
      {children}
    </DebugContext.Provider>
  );
}